import { render, staticRenderFns } from "./LogTable.vue?vue&type=template&id=90c892e2&"
import script from "./LogTable.vue?vue&type=script&lang=ts&"
export * from "./LogTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports